<script setup>
import SectionTop from "@/components/additional/SectionTop.vue";
import Button from "@/components/base/Button.vue";
import { handleAnchorClick } from "@/utils/scrollToAnchor";
</script>

<template>
  <section class="who-we-are relative" id="who-we-are">
    <SectionTop>Who We Are</SectionTop>
    <div class="who-we-are__content flex justify-between">
      <h4 class="text-l" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">Galazia is a forward-thinking gaming operator dedicated to delivering innovative, secure, and engaging entertainment experiences to a global audience. </h4>
      <div class="flex flex-col">
        <p class="text-ms" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">We are backed by international industry experts and built on principles of agility, trust, and relentless innovation. Our diverse team of product developers, engineers, and operational leaders is united by a passion for creating seamless experiences for players worldwide.</p>
        <Button @click="handleAnchorClick('#contacts')">Contact us</Button>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.who-we-are {
  padding: 11.111vw 8.333vw 9.722vw;
  &__content {
    margin: 3.472vw 0 0;
    gap: 5%;
    h4, p {
      font-family: "Rajdhani", sans-serif;
    }
    p {
      color: rgba(255, 255, 255, 0.70);
    }
    h4 {
      width: 45%;
    }
    div {
      gap: 2.778vw;
      width: 39%;
    }
  }
}

@media (max-width: 768px) {
  .who-we-are {
    padding: 50px 24px;
    &__content {
      flex-direction: column;
      margin: 34px 0 0;
      gap: 40px;
      h4, div {
        width: 100%;
      }
      h4 {
        line-height: 37px;
      }
      & > div {
        gap: 26px;
      }
    }
  }
}
</style>